import { client } from '@api/client';
import { URL } from '@api/urls';

import { IItemsResponse } from '@interfaces/common/response';
import { IApprovalUnit, IApprovalUser } from '@interfaces/organisation/approvalUnits';
import {
	IApprovalUnitDTO,
	ICreateApprovalUnitDTO,
	IUnitId,
	IUpdateApprovalUnitDTO,
} from '@interfaces/organisation/dto/approvalUnitsDTO';
import { IShortUserInfo } from '@interfaces/user/user';

const {
	approvalUnit,
	approvalUnitUsers,
	approvalUsersOptions,
} = URL;

export const getFilterApprovalUsers = (): Promise<IApprovalUser[]> => {
	return client.get(`${approvalUnit}/${approvalUnitUsers}`);
};

export const getApprovalUnits = (data: IApprovalUnitDTO): Promise<IItemsResponse<IApprovalUnit>> => {
	return client.get(`${approvalUnit}/filter`, {
		params: {
			...data,
		},
	});
};

export const createApprovalUnit = (data: ICreateApprovalUnitDTO): Promise<void> => client.post(approvalUnit, data);

export const updateApprovalUnit = ({ data, unitId }: IUpdateApprovalUnitDTO): Promise<void> => {
	return client.put(`${approvalUnit}/${unitId}`, data);
};

export const deleteApprovalUnit = ({ unitId }: IUnitId): Promise<void> => {
	return client.delete(`${approvalUnit}/${unitId}`);
};

export const getApprovalUsersOptions = (): Promise<IShortUserInfo[]> => client.get(approvalUsersOptions);
